import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CallNotice } from '../../services/phone-call.service';

/**
 * The message shown after a click-to-call attempt.
 *
 * A snackbar was the obvious choice and the wrong one: the thing being said
 * here is an instruction the user may need to act on ("check 3CX is running"),
 * and a three-second toast is gone before they have read it. So it stays until
 * dismissed, and carries the number so it can be dialled by hand if needed.
 */
@Component({
  selector: 'app-call-notice',
  templateUrl: './call-notice.component.html',
  styleUrls: ['./call-notice.component.css'],
})
export class CallNoticeComponent {
  @Input() notice: CallNotice | null = null;

  @Output() dismiss = new EventEmitter<void>();

  /** Icon and colour follow the outcome rather than being passed in. */
  get icon(): string {
    switch (this.notice?.outcome) {
      case 'dialling':
        return 'phone_in_talk';
      case 'no-number':
        return 'phone_disabled';
      default:
        return 'info';
    }
  }

  get toneClass(): string {
    return `call-notice--${this.notice?.outcome || 'info'}`;
  }
}
